"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

function readCodeFromUrl(): string {
  if (typeof window === "undefined") return "";
  const params = new URLSearchParams(window.location.search);
  return (
    params.get("code") ??
    params.get("redeem") ??
    params.get("redemptionCode") ??
    ""
  ).trim();
}

function buildStartHref(code: string): string {
  return code ? `/chat?code=${encodeURIComponent(code)}` : "/chat";
}

export function GuideStartLink({ variant = "top" }: { variant?: "top" | "primary" }) {
  const [code, setCode] = useState("");

  useEffect(() => {
    setCode(readCodeFromUrl());
  }, []);

  const href = buildStartHref(code);

  if (variant === "primary") {
    return (
      <Link className="guide-primary-link" href={href}>
        获取教练专属方案
      </Link>
    );
  }

  return (
    <Link className="guide-start-link" href={href}>
      开始咨询
    </Link>
  );
}
